const fixedClass = 'simple-nav--fixed';
const showDesktopNav = 992; // resources/assets/sass/general/_vars.scss $show-desktop-nav

function setup() {
  const nav = document.querySelector('.simple-nav');
  const navToggle = document.querySelector('#simple-nav-show');
  let scrollPos = 0;

  function closeMobileNavOnBigScreen() {
    if (window.innerWidth > showDesktopNav) {
      navToggle.checked = false;
      document.body.style.overflow = '';
    }
  }

  function setNavFixed() {
    if (nav.getBoundingClientRect().top <= 0) {
      nav.classList.add(fixedClass);
    } else {
      nav.classList.remove(fixedClass);
    }
  }

  function lockBodyScroll() {
    document.body.style.overflow = navToggle.checked ? 'hidden' : '';
  }

  window.addEventListener('resize', closeMobileNavOnBigScreen);
  window.addEventListener('resize', setNavFixed);
  window.addEventListener('scroll', setNavFixed);
  navToggle.addEventListener('change', lockBodyScroll);
}

window.addEventListener('DOMContentLoaded', setup);
